import {
  API_ENDPOINTS,
  ApiResponse,
  MasterGroup,
  CreateMasterGroupDto,
  UpdateMasterGroupDto
} from '../api';
import httpClient from '../httpClient';

export const masterGroupService = {
  getList: async (params?: { search?: string; page?: number; limit?: number }) => {
    try {
      const response = await httpClient.get<ApiResponse<MasterGroup>>(
        API_ENDPOINTS.MASTER_GROUP.LIST,
        {
          params: {
            pageNumber: params?.page || 1,
            pageSize: params?.limit || 10,
            search: params?.search || ''
          }
        }
      );
      return response.data;
    } catch {
      return {
        pageNumber: params?.page || 1,
        pageSize: params?.limit || 10,
        totalPages: 0,
        totalRecords: 0,
        message: 'Failed to fetch data',
        data: []
      };
    }
  },

  getDetail: async (id: string) => {
    const response = await httpClient.get<ApiResponse<MasterGroup>>(
      API_ENDPOINTS.MASTER_GROUP.DETAIL(id)
    );
    return {
      ...response.data,
      data: response.data.data || response.data
    };
  },

  create: async (data: CreateMasterGroupDto) => {
    const response = await httpClient.post<ApiResponse<MasterGroup>>(
      API_ENDPOINTS.MASTER_GROUP.CREATE,
      data
    );
    return response.data;
  },

  update: async (id: string, data: UpdateMasterGroupDto) => {
    const response = await httpClient.put<ApiResponse<MasterGroup>>(
      API_ENDPOINTS.MASTER_GROUP.UPDATE,
      data
    );
    return response.data;
  },

  delete: async (id: string) => {
    const response = await httpClient.delete<ApiResponse<void>>(API_ENDPOINTS.MASTER_GROUP.DELETE, {
      data: { msGroupQuestionID: id }
    });
    return response.data;
  }
};
